'use client';

import PageHeader from '../ui/PageHeader';
import type { BreadcrumbItem } from '../ui/Breadcrumb';

interface BrandPageHeaderProps {
  breadcrumbs: BreadcrumbItem[];
  h1: string;
}

export const BrandPageHeader = ({ breadcrumbs, h1 }: BrandPageHeaderProps) => {
  return <PageHeader breadcrumbs={breadcrumbs} h1={h1} />;
};
